import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getItemsInCart } from '../../common/entities/selectors/checkout'
import { useAlgoliaItems } from '../../common/items/algoliaItems'
import { analyticsItemMapper } from '../../common/analytics/mappers'
import { useCurrentUserId } from '../../common/user/currentUser'

const EMPTY_ARRAY = []

const useAnalyticsItems = () => {
  const userId = useCurrentUserId()
  const items = useSelector((state) => getItemsInCart(state, { userId }))
  const itemIds = items.map((i) => i.get('objectId')).toArray()

  const { items: algoliaItems } = useAlgoliaItems(itemIds, { preserveInputOrder: true })

  return useMemo(
    () => algoliaItems?.map((item) => analyticsItemMapper(item)) ?? EMPTY_ARRAY,
    [algoliaItems]
  )
}

export default useAnalyticsItems
